<div *ngIf="opened" class="header-mobile-popup no-print" [class.submenu-opened]="submenuOpened" @panelToggle>
  <div class="menu-content">
    <div class="header-mobile-top">
      <div class="toggle-mobile-menu" (click)="close()">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
        <div class="line line-3"></div>
      </div>
      <a class="logo" [routerLink]="'/'">
        <span class="amadeus-word">Amadeus</span>
        <span class="direct-word">Direct</span>
      </a>
    </div>
    <div class="header-mobile-section">
      <ul class="header-mobile-menu">
        <li
          *ngFor="let item of menuItems; trackBy: menuItemTrackBy"
          [ngClass]="{
            'has-submenu': item.children.length,
            opened: item.opened
          }"
        >
          <ng-template [ngTemplateOutlet]="menuLink" [ngTemplateOutletContext]="{ item: item }"></ng-template>
          <ul *ngIf="item.children.length && item.opened" class="submenu" @slideToggle>
            <li *ngFor="let child of item.children; trackBy: menuItemTrackBy">
              <a
                [routerLink]="child.link"
                [class.active-link]="linkIsActive(child)"
                (click)="child.clickHandler(child.code, $event); close()"
                >{{ child.title }}</a
              >
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <div class="header-mobile-section">
      <ul class="header-mobile-menu">
        <li>
          <a [routerLink]="'/faq'" routerLinkActive="active-link">{{ faqString }}</a>
        </li>

        <ng-container *ngFor="let externalLink of externalLinks">
          <ng-container *ngIf="ssoCodes.indexOf(externalLink.code) !== -1; else extLink">
            <li>
              <a class="d-inline-block py-1" (click)="navigateBySSOLink(externalLink)">{{ externalLink.title }}</a>
            </li>
          </ng-container>
          <ng-template #extLink>
            <li>
              <a class="d-inline-block py-1" (click)="navigateByHttpLink(externalLink.external_link)">{{
                externalLink.title
              }}</a>
            </li>
          </ng-template>
        </ng-container>

        <li>
          <a *ngIf="loggedIn$ | async" (click)="logout()">{{ logOutString }}</a>
          <ng-template #logIn>
            <a [routerLink]="'/login'" routerLinkActive="active-link">{{ landingSignInString }}</a>
          </ng-template>
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #menuLink let-item="item">
  <ng-container [ngSwitch]="item.item_type">
    <a *ngSwitchCase="'external_link'" target="_blank" rel="noopener noreferrer" [href]="item.external_link">{{
      item.title
    }}</a>
    <a *ngSwitchCase="'title'" (click)="toggleSubmenu(item)" [class.active-link]="linkIsActive(item)"
      >{{ item.title }}
      <ng-template *ngIf="item.children.length" [ngTemplateOutlet]="arrowIcon"></ng-template>
    </a>
    <a
      *ngSwitchDefault
      (click)="toggleSubmenu(item) || close()"
      [routerLink]="[item.link]"
      routerLinkActive="active-link"
      >{{ item.title }}
      <ng-template *ngIf="item.children.length" [ngTemplateOutlet]="arrowIcon"></ng-template>
    </a>
  </ng-container>
</ng-template>
<ng-template #arrowIcon>
  <svg class="arrow" style="width:24px;height:24px">
    <use href="'/assets/images/svg_ico/icons.svg#ic_keyboard_arrow_down'"></use>
  </svg>
</ng-template>
